import { render, staticRenderFns } from "./Orgnazition.vue?vue&type=template&id=56d9bb47&scoped=true"
import script from "./Orgnazition.vue?vue&type=script&lang=js"
export * from "./Orgnazition.vue?vue&type=script&lang=js"
import style0 from "./Orgnazition.vue?vue&type=style&index=0&id=56d9bb47&prod&lang=less&scoped=true"
import style1 from "./Orgnazition.vue?vue&type=style&index=1&id=56d9bb47&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d9bb47",
  null
  
)

export default component.exports